module.exports = __webpack_public_path__ + "media/images/emblems/Corcelles-pres-Concise-coat_of_arms-faec258c2266c473217af43725e988a7.svg";